import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchAPI } from './fetchAPI';

interface AuthenticatorSetupOutput {
  url: string;
}

export interface ActivateNewAuthenticatorOutput {
  success: boolean;
}

export interface AuthenticatorEnabledOutput {
  enabled: boolean;
}

export const useDeleteAuthenticator = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const endpoint = `v1/mfa/authenticator/delete`;
      await fetchAPI(endpoint);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['authenticatorEnabled'],
      });
      void queryClient.invalidateQueries({
        queryKey: ['authenticatorSetupUrl'],
      });
    },
  });
};

export const useAuthenticatorEnabled = () => {
  return useQuery({
    queryKey: ['authenticatorEnabled'],
    queryFn: async () => {
      const endpoint = `v1/mfa/authenticator/enabled`;
      return await fetchAPI<AuthenticatorEnabledOutput>(endpoint);
    },
  });
};

export const useCreateAuthenticatorSetupUrl = () => {
  return useQuery({
    queryKey: ['authenticatorSetupUrl'],
    queryFn: async () => {
      const endpoint = `v1/mfa/authenticator/initialize`;
      return await fetchAPI<AuthenticatorSetupOutput>(endpoint);
    },
  });
};

export const useActivateNewAuthenticator = () => {
  return useMutation({
    mutationFn: async (code: string) => {
      const endpoint = `v1/mfa/authenticator/initialize`;
      return await fetchAPI<ActivateNewAuthenticatorOutput>(endpoint, {
        method: 'POST',
        body: {
          code: code,
        },
      });
    },
  });
};
